import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';

import { DialogService } from 'primeng/dynamicdialog';

export const contactsRoutes: Routes = [
  {
    path: 'contacts',
    loadComponent: () =>
      import('@feature/setting/contacts/contacts.component').then(
        m => m.ContactsComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [permissionGuard('DispatcherContactsView')],
        loadComponent: () =>
          import('@feature/setting/contacts/contacts-list/contacts-list.component').then(
            m => m.ContactsListComponent
          ),
      },
      {
        path: 'job-titles',
        canActivate: [permissionGuard('DispatcherJobTitleView')],
        loadComponent: () =>
          import('./job-titles/job-titles.component').then(
            m => m.JobTitlesComponent
          ),
      },
      {
        path: 'responsibilities',
        canActivate: [permissionGuard('DispatcherResponsibilitiesView')],
        loadComponent: () =>
          import('@feature/setting/contacts/responsibilities/responsibilities.component').then(
            m => m.ResponsibilitiesComponent
          ),
      },
    ],
    providers: [DialogService],
  },
];
